import { FC } from "react";
import { FormControl } from "@mui/material";
import { Box, styled } from "@mui/system";
import { H5, Span } from "../Typography";

const StyledForm = styled("form")(() => ({
  width: "100%",
}));

const InputBox = styled(FormControl)(() => ({
  width: "100%",
  margin: "8px 0px",
}));

const styleObj = {
  margin: "10px 0px",
  width: "100%",
  padding: ".6rem .8rem",
  fontSize: ".9rem",
  borderRadius: "5px",
  lineHeight: "1.5",
  border: "none",
  transition: "all .3s",
};

const StyledInput = styled("input")(({ theme }) => ({
  ...styleObj,
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[50]
      : theme.palette.grey[800],
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[300] : "#f5f8fa",
  "&:focus": {
    outline: "none",
    backgroundColor: theme.palette.mode === "light" && "#ecf0f3",
  },
}));

const StyledSelect = styled("select")(({ theme }) => ({
  ...styleObj,
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[50]
      : theme.palette.grey[800],
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[300] : "#f5f8fa",
  "&:focus": {
    outline: "none",
    backgroundColor: theme.palette.mode === "light" && "#ecf0f3",
  },
}));

const Error = styled(Span)(({ theme }) => ({
  color: theme.palette.error.main,
}));

const CardImgBox = styled(Span)(() => ({
  width: "80px",
  display: "flex",
  justifyContent: "space-between",
  position: "absolute",
  top: "36px",
  right: "10px",
  "& img": {
    width: "30px",
  },
}));

interface Props {
  handleClose?: any;
  setSuccessModal: (value: boolean) => void;
  register?: any;
  handleSubmit?: any;
  onSubmit?: any;
  errors?: any;
}
const PaymentMethodForm: FC<Props> = (props) => {
  const { register, handleSubmit, onSubmit, errors } = props;

  return (
    <>
      <StyledForm onSubmit={handleSubmit(onSubmit)}>
        <InputBox>
          <H5>
            Card Name <Span color="red">*</Span>
          </H5>
          <StyledInput
            type="text"
            placeholder="Example card"
            {...register("card_name", { required: true })}
          />
          {errors.card_name && <Error>Card name is required</Error>}
        </InputBox>

        <InputBox sx={{ position: "relative" }}>
          <H5>
            Card Number <Span color="red">*</Span>
          </H5>
          <StyledInput
            type="number"
            placeholder="4444 3333 2222 1111"
            {...register("card_number", { required: true })}
            sx={{ pr: "78px" }}
          />
          {errors.card_number && <Error>Card number is required</Error>}
          <CardImgBox>
            <img alt="" src="/assets/images/payment-cards/011-visa.svg" />
            <img alt="" src="/assets/images/payment-cards/022-paypal.svg" />
          </CardImgBox>
        </InputBox>

        <InputBox>
          <H5>
            CVC <Span color="red">*</Span>
          </H5>
          <StyledInput
            type="number"
            placeholder="CVC"
            {...register("cvc", { required: true })}
          />
          {errors.cvc && <Error>CVC is required</Error>}
        </InputBox>

        <Box display="flex">
          <InputBox sx={{ mr: "10px" }}>
            <H5>
              Month <Span color="red">*</Span>
            </H5>
            <StyledSelect {...register("month", { required: true })}>
              <option value="" selected disabled hidden>
                Month
              </option>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((number) => (
                <option value={`${number}`}>{number}</option>
              ))}
            </StyledSelect>
            {errors.month && <Error>Month is required</Error>}
          </InputBox>
          <InputBox sx={{ ml: "10px" }}>
            <H5>
              Year <Span color="red">*</Span>
            </H5>
            <StyledSelect {...register("year", { required: true })}>
              <option value="" selected disabled hidden>
                Year
              </option>
              {[2015, 2016, 2017, 2018, 2019, 2020, 2021].map((number) => (
                <option value={`${number}`}>{number}</option>
              ))}
            </StyledSelect>
            {errors.year && <Error>Year is required</Error>}
          </InputBox>
        </Box>
      </StyledForm>
    </>
  );
};

export default PaymentMethodForm;
